import { render, staticRenderFns } from "./datosForm.vue?vue&type=template&id=381f03e4&scoped=true&"
import script from "./datosForm.vue?vue&type=script&lang=js&"
export * from "./datosForm.vue?vue&type=script&lang=js&"
import style0 from "./datosForm.vue?vue&type=style&index=0&id=381f03e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381f03e4",
  null
  
)

export default component.exports